import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';

import useHelmet from 'hooks/useHelmet';
import AssessmentDetailsProvider from 'providers/AssessmentDetailsProvider';
import DatadogRUMProvider from 'providers/DatadogRUMProvider';
import NotificationProvider from 'providers/NotificationProvider';
import UserProvider from 'providers/UserProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  const [title] = useHelmet();
  return (
    <div data-testid="app-test-id">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <DatadogRUMProvider name="builder-dd-RUM">
            <AssessmentDetailsProvider>
              <NotificationProvider>
                <Outlet />
              </NotificationProvider>
            </AssessmentDetailsProvider>
            <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
          </DatadogRUMProvider>
        </UserProvider>
      </QueryClientProvider>
    </div>
  );
};

export default App;
